import type { AppRouter } from '@/server/api/root';
import type { TRPCLink } from '@trpc/client';
import { observable } from '@trpc/server/observable';
import { authFailed } from '../redux/redux-actions/auth';

/**
 * Show authentication pop-up if the request returns a 401 status code
 */
export const checkSessionLink: TRPCLink<AppRouter> = () => {
  return ({ next, op }) => {
    return observable((observer) => {
      const unsubscribe = next(op).subscribe({
        next(value) {
          observer.next(value);
        },
        error(err) {
          const trcpHttpStatus = err.shape?.data.httpStatus;
          if (trcpHttpStatus === 401) {
            import('@/app/store')
              .then((res) => {
                const store = res.default;
                store.dispatch(authFailed());
              })
              .catch((reason) => {
                throw reason;
              });
          }
          observer.error(err);
        },
        complete() {
          observer.complete();
        },
      });
      return unsubscribe;
    });
  };
};
